export type ClassificationEnum = 'PRODUCTIVE' | 'UNPRODUCTIVE' | 'NEUTRAL' | 'CUSTOM';

export const ClassificationEnumValues = {
    Productive: 'PRODUCTIVE' as ClassificationEnum,
    Unproductive: 'UNPRODUCTIVE' as ClassificationEnum,
    Neutral: 'NEUTRAL' as ClassificationEnum,
    Custom: 'CUSTOM' as ClassificationEnum,
};
